import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getHomeRouteForLoggedInUser } from '@/auth/utils'
import apps from './routes/apps'
import dashboard from './routes/dashboard'
import uiElements from './routes/ui-elements/index'
import pages from './routes/pages'
import chartsMaps from './routes/charts-maps'
import formsTable from './routes/forms-tables'
import others from './routes/others'

Vue.use(VueRouter)
// process.env.BASE_URL
const router = new VueRouter({
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'home-careers-jobs' }, target: '_blank' },
    ...apps,
    ...dashboard,
    ...pages,
    ...chartsMaps,
    ...formsTable,
    ...uiElements,
    ...others,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (to.path === '/careers' || to.path.startsWith('/careers/job/')) {
    return next()
  }

  if (to.path === '/careers/activate-account') {
    return next()
  }

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    // return next({ name: 'misc-not-authorized' })
    return next()
  }

// Inside the navigation guard
if (to.meta.redirectIfLoggedIn && isLoggedIn) {
  console.log('Redirecting user to the home route...');
  // Redirect to the home route for logged-in users
  next(getHomeRouteForLoggedInUser('admin')); // Ensure this returns a valid route object
 next();
} else {
  console.log('Proceeding with normal navigation...');
  // If no redirect condition is met, continue to the intended route

  next();


}

 

})

export default router
